import { createContext } from 'react';

export default createContext({ categories: [], wishes: [], user: null});